import { html, ref, when } from "@microsoft/fast-element";
// Show subtext when card is medium/large size OR when user needs to update app/edge version
// Use large text format except incorrect app/edge version, where different styling is required to fit all the text.
export const errorCardTemplate = (context, definition) => html `
<template>
    ${when((x) => x.widgetInstance.getWidgetProperty("size") != "small", cardWithSubtext)}
    ${when((x) => x.widgetInstance.getWidgetProperty("size") === "small" && x.widgetInstance.widgetErrorStateReason != "checkEdgeVersionError"
    && x.widgetInstance.widgetErrorStateReason != "checkAppVersionError", html `
            <Text class="large largeForSmallCard">${(x) => x.resources.WidgetOfflinePage_OfflineErrorMessage}</Text>
        `)}
    ${when((x) => x.widgetInstance.getWidgetProperty("size") === "small" &&
    (x.widgetInstance.widgetErrorStateReason === "checkAppVersionError" || x.widgetInstance.widgetErrorStateReason === "checkEdgeVersionError"), smallCardWithSubtext)}
    <fluent-button
        appearance="accent"
        @click=${(x) => x.retry()}
        ${ref("reloadButton")}>
            ${(x) => x.resources.WidgetOfflinePage_ReloadButtonText}
    </fluent-button>
</template>
`;
const cardWithSubtext = () => html `
    ${when((x) => (x.widgetInstance.widgetErrorStateReason != "checkEdgeVersionError" && x.widgetInstance.widgetErrorStateReason != "checkAppVersionError"), html `
            <Text class="large">${(x) => x.resources.WidgetOfflinePage_OfflineErrorMessage}</Text>
            <Text class="medium"> ${(x) => x.resources.WidgetOfflinePage_OfflineErrorSubtext}</Text>
        `)}
    ${when((x) => x.widgetInstance.widgetErrorStateReason === "checkAppVersionError"
    || x.widgetInstance.widgetErrorStateReason === "checkEdgeVersion", html `
            <Text class="large">${(x) => x.resources.WidgetOfflinePage_OfflineErrorMessage}
                <a href="https://go.microsoft.com/fwlink/?linkid=2222462">
                        ${(x) => x.resources.SettingsDialog_LearnMoreLinkText}
                </a>
            </Text>
        `)}
`;
const smallCardWithSubtext = () => html `
        ${when((x) => x.widgetInstance.widgetErrorStateReason === "checkAppVersionError"
    || x.widgetInstance.widgetErrorStateReason === "checkEdgeVersionError", html `
            <Text class="large largeForSmallCardSubtext">${(x) => x.resources.WidgetOfflinePage_OfflineErrorMessage} </Text>
            <Text class="medium mediumForSmallCardSubtext">
                <a href="https://go.microsoft.com/fwlink/?linkid=2222462">
                        ${(x) => x.resources.SettingsDialog_LearnMoreLinkText}
                </a>
            </Text>
        `)}
`;
